<script setup lang="ts">
import { CloseIcon9 } from '@/assets'
import { ToastClose, ToastDescription, ToastRoot, ToastTitle } from 'reka-ui'
</script>

<template>
  <ToastRoot v-bind="$attrs" class="toast-message">
    <div class="icon-container">
      <slot name="icon"></slot>
    </div>
    <div class="toast-body">
      <ToastTitle class="toast-title"><slot name="title"></slot></ToastTitle>
      <ToastDescription class="toast-content"><slot></slot></ToastDescription>
    </div>
    <div class="close-section">
      <ToastClose class="close-button">
        <CloseIcon9 />
      </ToastClose>
    </div>
  </ToastRoot>
</template>

<style lang="scss">
.toast-message {
  width: 400px;
  max-width: calc(100vw - 32px);
  max-height: 600px; //Not very flexible but alternative is using js
  border-radius: 12px;
  background-color: var(--ullib-color-contrast);
  box-shadow: 0px 3px 24px var(--ullib-color-shadow-toast);
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.toast-message[data-state='open'] {
  animation: toast-animation-slidein 300ms ease-out;
}
.toast-message[data-state='closed'] {
  animation: toast-animation-hide 250ms ease-out;
}
.toast-message[data-swipe='move'] {
  transform: translateX(var(--reka-toast-swipe-move-x));
  opacity: calc(1 - var(--reka-toast-swipe-move-x) / 80px);
}
.toast-message[data-swipe='cancel'] {
  transform: translateX(0);
  transition: transform 200ms ease-out;
}
.toast-message[data-swipe='end'] {
  animation: toast-animation-swipeout 300ms ease-out;
}

@keyframes toast-animation-hide {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  70% {
    transform: translateX(80px);
    opacity: 0;
  }
  100% {
    transform: translateX(80px);
    opacity: 0;
    max-height: 0px;
  }
}

@keyframes toast-animation-slidein {
  from {
    transform: translateX(80px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes toast-animation-swipeout {
  0% {
    transform: translateX(var(--reka-toast-swipe-end-x));
    opacity: calc(1 - var(--reka-toast-swipe-end-x) / 80px);
  }
  70% {
    transform: translateX(calc(500px + 80px));
    opacity: 0;
  }
  100% {
    transform: translateX(calc(500px + 80px));
    opacity: 0;
    max-height: 0px;
  }
}
</style>

<style lang="scss" scoped>
.icon-container {
  width: 52px;
  padding-top: 28px;
  padding-bottom: 38px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.toast-body {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
  flex-grow: 1;
}

.toast-title {
  color: var(--ullib-color-primary);
  margin-bottom: 10px;
  word-break: break-all;
}

.toast-content {
  color: var(--ullib-color-headerSmall);
  word-break: break-all;
}

.close-section {
  flex-shrink: 0;
}

.close-button {
  border: none;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 14px;
  margin-top: 2px;
  margin-right: 2px;
}
</style>
